import { GetAreaDayRepresentativeness } from '@protector/entities/region/__legacy__/redux.actions';
import { ofType, type ActionsObservable } from 'redux-observable';
import { concat, of } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';
import {
  LoadAreaDayMonitoringFailure,
  LoadAreaDayMonitoringSuccess,
  MonitoringActionsTypes,
  type LoadAreaDayMonitoring
} from './monitoring.actions';
import MonitoringService from './monitoring.service';

export const handleAreaDayMonitoring = (action$: ActionsObservable<ReturnType<typeof LoadAreaDayMonitoring>>) => {
  return action$.pipe(
    ofType(MonitoringActionsTypes.LOAD_AREA_DAY_MONITORING),
    map(action => action.payload),
    concatMap(({ propertyId, areaId, day, showRepresentativeness, representedPointsIds, areaPointsIds }) => {
      const monitoringObservable = showRepresentativeness
        ? MonitoringService.getMonitoring(propertyId, day)
        : MonitoringService.getMonitoringAreaDay(propertyId, areaId, day);
      return monitoringObservable.pipe(
        concatMap(monitoringValues => {
          const actions = showRepresentativeness
            ? [
                LoadAreaDayMonitoringSuccess(monitoringValues),
                GetAreaDayRepresentativeness(monitoringValues, day, areaId, representedPointsIds, areaPointsIds)
              ]
            : [LoadAreaDayMonitoringSuccess(monitoringValues)];
          return concat(actions);
        }),
        catchError((error: string) => of(LoadAreaDayMonitoringFailure(error)))
      );
    })
  );
};
